import React from 'react';
import PropTypes from 'prop-types';
import TooltipWrapper from './TooltipWrapper';

const propTypes = {
	id: PropTypes.string.isRequired,
	children: PropTypes.node,
	placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	tooltipTitle: PropTypes.string,
	className: PropTypes.string,
    trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    delay: PropTypes.number,
    icon: PropTypes.string, // fontawesome icon classname
    triggerElem: PropTypes.element, // optional. replace font awesome icon with custom element
    disabled: PropTypes.bool,
    'aria-label': PropTypes.string,
    title: PropTypes.string
};

const defaultProps = {
	children: null,
	placement: 'top',
	tooltipTitle: '',
	className: '',
    trigger: ['hover', 'focus'],
    delay: 100,
    icon: 'fa-question-circle-o',
    triggerElem: null,
    disabled: false,
    'aria-label': '',
    title: ''
};

function Tooltip(props) {
	return (
        <TooltipWrapper
            toolTipContent={props.children}
            id={props.id}
            className={`glyph ${props.className}`}
            placement={props.placement}
            tooltipTitle={props.tooltipTitle}
            trigger={props.trigger}
            delay={props.delay}
            disabled={props.disabled}
            aria-label={props['aria-label']}
            title={props.title}
        >
            {(!!props.triggerElem) ?
                props.triggerElem
                :
                <span className={`fa ${props.icon}`} aria-hidden={true}/>
            }
        </TooltipWrapper>
    );
}

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

export default Tooltip;
